import React from 'react';
import '../css/AnalysisDetail.css';
import Phase3Results from './Phase3Results';

interface AnalysisDetailProps {
  sessionId: string;
  onBack: () => void;
  title?: string;
  onStatusChange?: (status: 'download' | 'completed') => void;
}

const AnalysisDetail: React.FC<AnalysisDetailProps> = ({ sessionId, onBack, onStatusChange }) => {
  return (
    <div className="analysis-detail-container">
      <div className="analysis-detail-content">
        <div className="tab-content">
          <Phase3Results
            sessionId={sessionId}
            workflowData={{}}
            onRestart={onBack}
            onStatusChange={onStatusChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalysisDetail;
